import { useAuth } from '@/shared/contexts/AuthContext';
import { AppShell } from '@/shared/components/layout';

/** Página para tenant autenticado cuja empresa está suspensa. */
export default function ContaSuspensaPage() {
  const { signOut } = useAuth();

  return (
    <AppShell ambient>
      <div className="flex min-h-dvh flex-col items-center justify-center px-4 py-10 pb-[calc(2.5rem+env(safe-area-inset-bottom))] pt-[calc(2.5rem+env(safe-area-inset-top))]">
        <div className="w-full max-w-sm text-center">
          <div className="w-16 h-16 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-5">
            <svg className="w-7 h-7 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
              />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-white">Conta suspensa</h1>
          <p className="mt-2 text-sm leading-6 text-slate-400">
            O acesso ao painel foi bloqueado. Regularize sua assinatura com o suporte.
          </p>
          <button
            type="button"
            onClick={() => void signOut()}
            className="mt-6 min-h-11 rounded-xl border border-white/10 bg-white/5 px-4 py-2.5 text-sm text-slate-300 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/60"
          >
            Sair
          </button>
        </div>
      </div>
    </AppShell>
  );
}
